import { Injectable } from '@angular/core';

import { RestService } from '../core/rest.service';

import { objectToQueryString } from '../../common/utils';

import { environment } from '../../../environments/environment';

@Injectable()
export class AdminUserService {
  constructor(private readonly rest: RestService) {}

  getUsers(params: any = null): Promise<any> {
    if (params) {
      const queryParams = objectToQueryString(params);
      return this.rest.get(`${environment.apiUrl}/api/admin/user${queryParams}`);
    } else {
      return this.rest.get(`${environment.apiUrl}/api/admin/user`);
    }
  }

  getUserById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/admin/user/${id}`);
  }

  generateUserJwt(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/admin/user/${id}/!generate-jwt`);
  }

  createUser(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/admin/user`, payload);
  }

  updateUser(id: number, payload): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/admin/user/${id}`, payload);
  }

  setUserPassword(id: number, payload: { password: string }): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/admin/user/${id}/!set-password`, payload);
  }
}
